import { handleActions } from 'redux-actions';
import * as Actions from '../constants/actions';
import { StoryInfo, SelectedStory } from '../models/Story';

const initialState: StoryInfo[] = [];

const initialSelectedStory: SelectedStory = {
	campaign_id: "",
	student_id: ""
};

const storyInfoReducers = handleActions<StoryInfo[], any>(
	{

		[Actions.STORY_ADD]: (state, action) => {
			let stories = state.slice();
			stories.push(action.payload.info);
			return stories;
		},

		[Actions.STORY_DELETE]: (state, action) => {
			let stories = state.slice();
			const story = action.payload;
			stories = stories.filter(element => element._id !== story._id);
			return stories;
		},

		[Actions.SET_STORIES]: (state, action) => {
			return Object.keys(action.payload).map(key => action.payload[key]);
		},

		[Actions.STORY_MARK_GRADED]: (state, action) => {
			const stories = state.slice();
			const story = action.payload;
			stories.find(element => element._id == story._id).graded = story.graded;
			return stories;
		},

		[Actions.STORY_MARK_IMPORTANT]: (state, action) => {
			const stories = state.slice();
			const story = action.payload;
			stories.find(element => element._id == story._id).important = story.important;
			return stories;
		}
	},
	initialState
);

const selectedStoryReducers = handleActions<SelectedStory>(
	{
		[Actions.SET_SELECTED_STORY]: (state, action) => {
			console.log(state);
			return action.payload;
		}
	},
	initialSelectedStory
);

export {selectedStoryReducers, storyInfoReducers}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/stories.ts